import Button from '@mui/material/Button'
import React from 'react'
import { useStyles } from './styles'
import { CircularProgress } from '@mui/material'
import WebApp from '@twa-dev/sdk'

type ButtonProps = Omit<React.ComponentProps<typeof Button>, 'onClick' | 'variant'> & {
  children: React.ReactNode
  fullWidth?: boolean
  onClick?: () => void
  variant?: 'primary' | 'secondary' | 'transparent' | 'golden' | 'special' | 'storiesReward' | 'storiesRewardPrimary'
  classes?: Record<string, string | undefined>
  isLoading?: boolean
  disabled?: boolean
}

export const AppButton = (props: ButtonProps) => {
  const { children, variant = 'primary', fullWidth, onClick, isLoading = false, ...rest } = props
  const { classes } = useStyles({ classesOverrides: props.classes })

  function handleClick() {
    if (onClick) onClick()
    WebApp.HapticFeedback.impactOccurred('soft')
  }
  return (
    <Button
      {...rest}
      data-variant={variant}
      onClick={handleClick}
      data-fullwidth={fullWidth}
      classes={{ root: classes.root }}
      variant="contained"
      disabled={isLoading || props.disabled}
      data-isloadinggolnden={variant === 'golden' && isLoading}
    >
      {isLoading ? (
        <CircularProgress
          sx={{ color: (isLoading && variant === 'golden' && 'black') || 'inherit' }}
          size={20}
        />
      ) : (
        children
      )}
      {/*{(variant === 'storiesReward' || variant === 'storiesRewardPrimary') &&*/}
      {/*  (isLoading || props.disabled ? (*/}
      {/*    <img*/}
      {/*      src="https://storage.googleapis.com/gamed-games-bucket/pictures/stuff/shareRewardDisabled.webp"*/}
      {/*      alt="Disabled Reward"*/}
      {/*    />*/}
      {/*  ) : (*/}
      {/* TODO: update broken link of this icon; then uncomment this block */}
      {/*    <img*/}
      {/*      src="https://storage.googleapis.com/gamed-games-bucket/pictures/stuff/shareReward.webp"*/}
      {/*      alt="Reward"*/}
      {/*    />*/}
      {/*  ))}*/}
    </Button>
  )
}
